import BigNumber from 'bignumber.js'

import { CardBody, Flex, Text, CardRibbon } from '@pancakeswap/uikit'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { useTranslation } from 'contexts/Localization'
import { BIG_TEN, BIG_ZERO } from 'utils/bigNumber'
import { DeserializedPool } from 'state/types'
import { TokenImage, TokenPairImage } from 'components/TokenImage'
import { usePool } from 'state/pools/hooks'
import AprRow from './AprRow'
import { StyledCard } from './StyledCard'
import CardFooter from './CardFooter'
import PoolCardHeader, { PoolCardHeaderTitle } from './PoolCardHeader'
import CardActions from './CardActions'

const PoolCard: React.FC<{ pool: any; account: string }> = ({ pool, account }) => {
  const { sousId, stakingToken, earningToken, isFinished, userData } = pool
  const { t } = useTranslation()
  const stakedBalance = userData?.stakedBalance ? new BigNumber(userData.stakedBalance) : BIG_ZERO
  const accountHasStakedBalance = stakedBalance.gt(0)

  const bnbPool = usePool(38)
  const normalPrice = Number(bnbPool.pool.busdPrice)
  const normalPriceBnb = new BigNumber(normalPrice / Number(bnbPool.pool.tokenPrice))
  const priceInBnb = pool.tokenPrice
    ? new BigNumber(pool.earningTokenPrice.toString()).times(new BigNumber(pool.tokenPrice.toString()))
    : BIG_ZERO

  // const isCakePool = earningToken.symbol === 'HODLX' && stakingToken.symbol === 'HODLX'
  const discountRate = 1 - priceInBnb.div(normalPriceBnb).toNumber()

  const discountRatePercent =
    pool.discountRate !== undefined ? pool.discountRate.toString() : (Number(discountRate) * 100).toFixed(0)
  const discountSave = bnbPool.pool.busdPrice
    ? new BigNumber(bnbPool.pool.busdPrice.toString()).times(new BigNumber(discountRate))
    : BIG_ZERO

  const priceBUSD = bnbPool.pool.tokenPrice
    ? priceInBnb.times(new BigNumber(bnbPool.pool.tokenPrice.toString())).toNumber()
    : 0

  return (
    <StyledCard
      isFinished={isFinished && sousId !== 0 && sousId !== 15}
      ribbon={isFinished && <CardRibbon variantColor="textDisabled" text={t('Finished')} />}
    >
      <PoolCardHeader isStaking={accountHasStakedBalance} isFinished={isFinished && sousId !== 0 && sousId !== 15}>
        <PoolCardHeaderTitle
          title={t('Buy Gem Fighter NFTs with $HODLX Token')}
          subTitle={t('Get a discount when buying with $HODLX!')}
        />
        <TokenPairImage primaryToken={earningToken} secondaryToken={stakingToken} width={64} height={64} />
      </PoolCardHeader>
      <CardBody>
        <AprRow
          pool={pool}
          stakedBalance={stakedBalance}
          discountRatePercent={discountRatePercent}
          discountSave={discountSave}
          busdPrice={priceBUSD}
        />
        <Flex mt="24px" flexDirection="column">
          {account ? (
            <CardActions pool={pool} stakedBalance={stakedBalance} discountSave={discountSave} busdPrice={priceBUSD} />
          ) : (
            <>
              <ConnectWalletButton />
            </>
          )}
        </Flex>
      </CardBody>
    </StyledCard>
  )
}

export default PoolCard
